import React, { forwardRef } from 'react';
import { View } from '@shared/components/View';
import { MBReactionButtonWithPicker } from '../components/reaction/buttonWithPicker';
import { useSelectedReactions, useToggleReaction } from './hooks';

interface Props {
  message: MBAPI.ChatMessage;
  channelSlug: string;
}

export const MBInvisibleReactionPicker = forwardRef<MBReactionButtonWithPicker, Props>(
  function MBInvisibleReactionPickerWithRef({ message, channelSlug }, ref) {
    const toggleReaction = useToggleReaction(message, channelSlug);
    const selected = useSelectedReactions(message);

    return (
      <View
        style={{
          height: 0,
          overflow: 'hidden',
          pointerEvents: 'none',
        }}
      >
        <MBReactionButtonWithPicker
          ref={ref}
          selected={selected}
          onToggleReaction={toggleReaction}
        />
      </View>
    );
  },
);
